const level = 6;
const Role = {
  path: "",
  name: "",
  redirect: "/role",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "/role",
      redirect: "/role",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      name: "Role List",
      meta: {
        requiresAuth: true,
        activeUrl: "/role",
        parent: "/role",
        lv: level,
      },
      children: [
        {
          path: "",
          name: "",
          component: () => import("@/views/pages/role"),
          meta: {
            requiresAuth: true,
            activeUrl: "/role",
            parent: "/role",
            lv: level,
          },
        },
        {
          path: "/role/details/:id",
          name: "Manage Role",
          component: () => import("@/views/pages/role/detail/index.vue"),
          meta: {
            requiresAuth: true,
            lv: level,
            isChildren: true,
            activeUrl: "/role",
          },
        },
      ],
    },
  ],
  meta: { requiresAuth: true },
};
export default Role;
